<!-- DEPRECATED: wraps ImageCtaLarge. Use that instead. -->
<template>
    <image-cta-large
        :body-html="subHeader"
        :button-text="buttonText"
        :button-link="buttonLink"
        :version="widgetOption"
    >
        <slot>Explore electric vehicles</slot>
    </image-cta-large>
</template>

<script>
import ImageCtaLarge from '@/widgets/image_cta_large/ImageCtaLarge';

export default {
    components: {
        ImageCtaLarge,
    },
    props: {
        subHeader: {
            type: String,
            required: true,
        },
        buttonText: {
            type: String,
            required: false,
            default: 'Learn More',
        },
        buttonLink: {
            type: String,
            required: false,
            default: 'https://electricvehicles.energysage.com/',
        },
        widgetOption: {
            type: String,
            required: true,
        },
    },
};
</script>
